<!--
 * @Descripttion: 仪表盘
 * @Author: zenghua.wang
 * @Date: 2021-09-22 09:51:01
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-01-11 17:09:38
-->
<template>
  <div
    ref="container"
    :class="setClass()"
    :style="styleSize"
    v-custom-loading="loading"
    :custom-loading-text="component.loadingText"
    :custom-loading-spinner="component.loadingSpinner"
    :custom-loading-background="component.loadingBackground"
  >
    <div
      :ref="id"
      :style="styleChart"
    ></div>
  </div>
</template>

<script>
import bem from '@/dragComponents/mixins/bem'
import customLoading from '@/dragComponents/directive/loading'
import echart from '@/dragComponents/mixins/echart'
import {
  isEmpty,
  deepClone,
  isHasProp,
  setTooltipFormatter
} from '@/dragComponents/utils'
import { component } from '@/dragComponents/model/default.js'
import mock from '@/dragComponents/model/mock.js'

export default {
  name: 'drag-echart-gauge',
  mixins: [bem, echart],
  directives: { customLoading },
  data() {
    return {
      component: component
    }
  },
  methods: {
    setOption() {
      const optionData = deepClone(this.optionData)
      let option = {
        series: [
          {
            type: this.option.type,
            center: [this.option.centerX + '%', this.option.centerY + '%'],
            radius: this.option.centerR + '%',
            startAngle: this.option.startAngle,
            endAngle: this.option.endAngle,
            min: this.option.min,
            max: this.option.max,
            splitNumber: this.option.splitNumber,
            progress: {
              show: this.option.progressShow,
              roundCap: this.option.roundCap,
              width: this.option.lineWidth + 1,
              itemStyle: {
                color: this.option.progressColor
              }
            },
            axisLine: {
              roundCap: this.option.roundCap,
              lineStyle: {
                width: this.option.lineWidth,
                color: (() => {
                  let list = []
                  if (this.option.defaultColor) {
                    list = !isEmpty(this.option.lineColor)
                      ? [[1, this.option.lineColor]]
                      : [[1, '#E6EBF8']]
                  } else {
                    if (!isEmpty(this.option.color)) {
                      let len = this.option.color.length
                      let postion = 1 / len
                      this.option.color.forEach((ele, index) => {
                        list.push([(index + 1) * postion, ele])
                      })
                    } else {
                      list = [[1, '#E6EBF8']]
                    }
                  }
                  return list
                })()
              }
            },
            axisTick: {
              show: this.option.axisTickShow,
              length: this.option.axisTickLength,
              lineStyle: {
                color: this.option.axisTickColor || 'auto',
                width: this.option.axisTickWidth
              }
            },
            splitLine: {
              show: this.option.splitLineShow,
              length: this.option.splitLineLength,
              lineStyle: {
                color: this.option.splitLineColor || 'auto',
                width: this.option.splitLineWidth
              }
            },
            pointer: {
              show: this.option.pointerShow,
              // icon: 'path://M12.8,0.7l12,40.1H0.7L12.8,0.7z',
              length: this.option.pointerLength + '%',
              width: this.option.pointerWidth,
              offsetCenter: [0, 0],
              itemStyle: {
                color: this.option.pointerColor || 'auto'
              }
            },
            anchor: {
              show: this.option.anchorShow,
              size: this.option.anchorSize || 6,
              showAbove: true,
              itemStyle: {
                color: this.option.anchorColor || 'auto'
              }
            },
            axisLabel: isHasProp(
              !isEmpty(this.option.labelFormatter),
              {
                formatter: (value) => {
                  let params = { name: null, value: value }
                  return setTooltipFormatter(
                    this.option.labelFormatter,
                    params,
                    this.dataList
                  )
                }
              },
              {
                show: this.option.labelShow,
                distance: this.option.labelDistance,
                color: this.option.labelColor,
                fontSize: this.option.labelFontSize
              }
            ),
            title: {
              show: this.option.gaugeTitleShow,
              color: this.option.gaugeTitleColor,
              fontSize: this.option.gaugeTitleFontSize * (window?.scale || 1),
              offsetCenter: [0, this.option.gaugeTitleCenter + '%']
            },
            detail: {
              show: this.option.detailShow,
              fontSize: this.option.detailFontSize * (window?.scale || 1),
              color: this.option.detailColor,
              offsetCenter: [0, this.option.detailCenter + '%'],
              valueAnimation: true,
              formatter: (value) => {
                return !isEmpty(this.option.unit)
                  ? value + this.option.unit
                  : value
              }
            },
            data: optionData.series
          }
        ]
      }

      // console.log('gauge=', option)
      this.dragChart.resize()
      this.dragChart.setOption(option, true)
      this.isChart = true
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.init(mock.echart.gauge)
    })
  }
}
</script>
<style lang="scss" scoped>
@import '@/dragComponents/styles/echart/index.scss';
</style>
